import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SectionHeading from '@/components/base/SectionHeading';
import HeroCarousel from './components/HeroCarousel';
import CategoryQuickLinks from './components/CategoryQuickLinks';
import LatestFeed from './components/LatestFeed';
import HotRanking from './components/HotRanking';
import TagCloud from './components/TagCloud';
import SiteIntro from './components/SiteIntro';
import { getLatestArticles, getHotArticles } from '@/utils/articles';
import { useDocumentTitle } from '@/hooks/useDocumentTitle';

export default function Home() {
  useDocumentTitle({
    title: '91黑料网-最新黑料资讯与热门爆料平台',
    description:
      '91黑料网致力于提供最新的娱乐黑料、明星爆料和社会热点新闻，用户可在这里快速获取最新资讯和热门话题讨论。',
    keywords: '91黑料网,黑料资讯,明星爆料,娱乐黑料,热点新闻,最新爆料,社会新闻,热点资讯',
  });

  const focus = getHotArticles(4);
  const latest = getLatestArticles();

  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />

      <main className="mx-auto max-w-[1280px] px-4 py-6 md:px-6">
        <section className="animate-fade-up grid grid-cols-1 gap-6 lg:grid-cols-3">
          <div className="lg:col-span-2">
            <HeroCarousel items={focus} />
          </div>
          <div className="lg:col-span-1">
            <HotRanking />
          </div>
        </section>

        <section className="mt-8 animate-fade-up">
          <SectionHeading
            title="分类快捷入口"
            subtitle="按类型快速锁定你关心的爆料"
            icon="ri-apps-2-line"
          />
          <CategoryQuickLinks />
        </section>

        <section className="mt-8 grid grid-cols-1 gap-6 lg:grid-cols-3">
          <div className="lg:col-span-2">
            <SectionHeading
              title="最新资讯流"
              subtitle="时间倒序 · 24小时滚动"
              icon="ri-time-line"
            />
            <LatestFeed items={latest} />
          </div>

          <aside className="flex flex-col gap-6 lg:col-span-1">
            <div className="lg:sticky lg:top-28">
              <TagCloud />
              <div className="mt-6 rounded-lg border border-primary-200 bg-primary-50 p-4">
                <h3 className="flex items-center gap-2 text-sm font-bold text-foreground-950">
                  <i className="ri-megaphone-line text-primary-600"></i>
                  我要爆料
                </h3>
                <p className="mt-2 text-xs leading-relaxed text-foreground-600">
                  有独家线索想分享？欢迎发送邮件至
                  <span className="mx-1 font-medium text-primary-700">tip@91heiliao.com</span>
                  ，我们会严格保护你的隐私。
                </p>
              </div>
            </div>
          </aside>
        </section>

        <section className="mt-10 animate-fade-up">
          <SiteIntro />
        </section>
      </main>

      <Footer />
    </div>
  );
}